import dogimage from "../assets/dog-logo.jpg";
import weatherimage from "../assets/snowflake_weather_app.png";
import cartimage from "../assets/shoppingcart.jpg";
import frontendmentor from "../assets/frontendmentor.jfif";
import calender from "../assets/calender.png";
import healthy from "../assets/healthifyimage.png";

const Data = [
    {
        source : weatherimage,
        title : "React-powered weather companion.",
        tech_used : "ReactJS - CSS3",
        description : "Explore real-time forecasts, interactive visuals, and global coverage. Access hourly details, and enjoy responsive design.",
        link : "https://myweatherappaks.netlify.app/"
    }
    ,
    {
        source : calender,
        title : "Template for calendar 🗓️ app",
        tech_used : "ReactJS - CSS3 - Mui - Gfonts - AOS",
        description : "An all in one application with features like seamless scheduling, smart reminders and task, responsive, customizable alerts and much more.",
        link : "https://assignment-hq-aks.netlify.app/"
    }
    ,
    {
        source : healthy,
        title : "Healthify app",
        tech_used : "ReactJS - CSS3 - FontAwesome - Gfonts - ReactToast",
        description : "Find your Doctor and make an Appointments. Talk to online doctors and get medical advice, online prescriptions, refills and medical notes.",
        link : "https://healthifyaks.netlify.app/"
    }
    ,

    {
        source : cartimage,
        title : "Redux Shopping Cart",
        tech_used : "ReactJS - Redux",
        description : "By leveraging the power of React Redux, I've created an efficient and organized shopping experience that allows users to effortlessly add, remove,and update items in their cart.",
        link : "https://myshoppingcartaks.netlify.app/"
    }
    ,
    {
        source : dogimage,
        title : "Doge-Date",
        tech_used : "Bootstrap - CSS3",
        description : "front-end page for a Dating for dog website. The main framework used for building the Doge-date website is bootstrap4 and its components like Carousel, Card, Button, Navbar.",
        link : "https://akshatsc.github.io/Doge-Date/"
    }
    ,
    {
        source : frontendmentor,
        title : "FrontEnd Mentor",
        tech_used : "ReactJS - CSS3",
        description : "This contains link to My profile in Frontend mentor platform . It contains collection of various Challenges I have completed on the platform. It contains link to Code base as well as Task deployed link.",
        link : "https://www.frontendmentor.io/profile/AkshatSC"
    }
    ,
   
    
];

export default Data;